import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import Select from "react-select";

//
//{
//
//    "name":"Latesto O\u00dc",
//    "airtableId":"rec4iQSTveeQTJnJD",
//    "email":"rein.palipea@latesto.ee",
//    "phone":"+3725045647",
//    "address":", ",
//    "id":233,
//    "properties":[
//        {
//            "id":"13402:002:0400",
//            "status":"Ready to sign"
//        }
//    ],
//    "totalArea":6.44
//
//}


const { Formik } = formik;

class DialogScreeningMap extends React.Component {
	

	
	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}

	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	
	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		
		
		if(!this.props.user.userDetails)
			this.updateStatus({sent:true, success:false, message:'Login required'});
		this.forceUpdate();
	};

	handleSubmit(data){
		
		this.updateStatus({sent:false, success:false, message:'Saving...'});


		var projectToPost = {...data, settings: {}, layers:{}, email:this.props.user.userDetails};
		

		atlasApi.saveUserMap(projectToPost).then((data)=>{
			if(data.id){
				this.updateStatus({sent:true, success:true, message:'Project has been created'});
				
				if(this.props.onSave)
					this.props.onSave(data);
				
				setTimeout(()=>this.handleClose(), 500);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error saving Project'});
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error saving Project'});
		});
	};


	render() {
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>New Map</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.sandboxMap} onSubmit={this.handleSubmit.bind(this)} initialValues={{}}>	
					{({ handleSubmit, handleChange, values, touched, errors, control, setFieldValue }) => (
						
						<Form noValidate onSubmit={handleSubmit}>
							<input type="hidden" name="id" value={values.id} />
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>Map Name</Form.Label>
												<Form.Control type="text" name="title" placeholder="Map Name" value={values.name } onChange={handleChange} isValid={touched.title && !errors.title} isInvalid={errors.title}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										
									</Modal.Body>
									<Modal.Footer>
										<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="success" type="submit">Create Map</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogScreeningMap;